import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { NotificationsService } from "./../../common/services/notifications/notifications.service";

@IonicPage()
@Component({
	selector: "page-notification",
	templateUrl: "notification.html"
})
export class NotificationPage {
	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public notificationsService: NotificationsService
	) {}

	ionViewDidLoad() {
		//this.notificationsService.newNotifications = 0;
		// this.notificationsService.getNotifications(
		// 	this.notificationsService.url
		// );
		// this.notificationsService.getNotificationTypes();
	}
}



// WEBPACK FOOTER //
// ./src/pages/notification/notification.ts